<template>
  <v-container fluid>
    <v-card class="mb-5">
      <v-toolbar @click="toggleFilters()" flat>
        <v-toolbar-title class="grey--text">
          Filtros
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="showFilters" icon>
          <v-icon>mdi-chevron-up</v-icon>
        </v-btn>
        <v-btn v-else icon>
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>

      <v-card-text v-if="showFilters">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              label="Número"
              outlined
              dense
              hide-details
              single-line
              v-model="advanced_filters.numero"
              @keyup.enter="handleFilter()"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <ClientPicker
              hide-details
              outlined
              dense
              prepend_inner_icon=""
              single_response
              label="Cliente"
              v-model="advanced_filters.cliente"
              @keyup.enter="handleFilter()"
              single-line
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-autocomplete
              label="Vendedor"
              :items="users"
              item-text="name"
              item-value="id"
              outlined
              dense
              hide-details
              clearable
              single-line
              v-model="advanced_filters.vendedor"
              @keyup.enter="handleFilter()"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="6">
            <DatePicker
              label="Data"
              outlined
              dense
              single-line
              hide-details
              v-model="advanced_filters.data_criacao"
              @keyup.enter="handleFilter()"
              clearable
              prepend-icon=""
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              label="Valor"
              outlined
              dense
              hide-details
              single-line
              :items="total_options"
              v-model="valor_filtro_selecionado"
              @change="onAlterarFiltroValor"
              @keyup.enter="handleFilter()"
            ></v-select>
          </v-col>
          <v-col cols="12" md="3" v-if="valor_filtro_selecionado === 'outro'">
            <v-text-field
              label="Valor inicial"
              outlined
              dense
              hide-details
              single-line
              type="number"
              placeholder="Sem limite"
              :value="valor_outro_de"
              @input="onAlterarValorOutroDe"
              @keyup.enter="handleFilter()"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3" v-if="valor_filtro_selecionado === 'outro'">
            <v-text-field
              label="Valor final"
              outlined
              dense
              hide-details
              single-line
              type="number"
              placeholder="Sem limite"
              :value="valor_outro_ate"
              @input="onAlterarValorOutroAte"
              @keyup.enter="handleFilter()"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-select
              label="Forma de pagamento"
              outlined
              dense
              hide-details
              single-line
              :items="payment_types"
              item-text="description"
              item-value="id"
              multiple
              v-model="advanced_filters.tipo_de_pagamento_id"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip small v-if="index === 0">
                  <span>{{ item.description }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text caption">
                  (+{{ advanced_filters.tipo_de_pagamento_id.length - 1 }})
                </span>
              </template>
              <template v-slot:prepend-item>
                <v-list-item ripple @click="setVendasAVista()">
                  <v-list-item-content>
                    <v-list-item-title>Vendas à vista</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item ripple @click="setCrediario()">
                  <v-list-item-content>
                    <v-list-item-title>Crediário</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-select>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-btn @click="handleFilter()" color="primary">
          <v-icon small class="pr-2">mdi-filter</v-icon>
          Filtrar
        </v-btn>
        <v-btn @click="resetAdvancedFilters()" text>
          <v-icon small class="pr-2">mdi-filter-off</v-icon>
          Limpar
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title class="grey--text">
          Vendas por forma de pagamento
        </v-toolbar-title>
      </v-toolbar>
      <v-data-table
        :loading="loading"
        :items="items"
        :options.sync="options"
        :server-items-length="total_items"
        :headers="headers"
        hide-default-footer
        class="py-5"
        mobile-breakpoint="960"
      >
        <template v-slot:item.numero="{ item }">
          <router-link
            :to="{
              name: 'edit_pedido',
              params: { numero: item.numero },
              query: { from: 'relatorio-vendas-por-forma-de-pagamento' }
            }"
          >
            {{ item.numero }}
          </router-link>
        </template>
        <template v-slot:item.created_at="{ item }">
          {{ formatDateTime(item.created_at) }}
        </template>
        <template v-slot:item.total_venda="{ item }">
          {{ formatMoney(item.total_venda) }}
        </template>
        <template v-slot:footer="{ props, on }">
          <v-data-footer
            v-bind="props"
            v-on="on"
            :items-per-page-options="[5, 10, 15, 20]"
          />
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { index } from "@/services/relatorio_vendas";
import { index as indexPaymentTypes } from "@/services/payment_types";
import { format as formatMoney } from "@/utils/money";
import ClientPicker from "@/components/ClientPicker";
import DatePicker from "@/components/tools/DatePicker";
import DateTimeMixin from "@/mixins/DateTimeMixin";

const STORAGE_KEY = "sales_by_payment_report_options";

export default {
  mixins: [DateTimeMixin],
  components: { ClientPicker, DatePicker },
  data: () => ({
    showFilters: true,
    items: [],
    users: [],
    payment_types: [],
    loading: false,
    options: {
      itemsPerPage: 10,
      sortBy: ["created_at"],
      sortDesc: [true]
    },
    total_items: 0,
    headers: [
      { text: "Número", value: "numero", width: 120 },
      { text: "Data/hora", value: "created_at", width: 180 },
      { text: "Cliente", value: "cliente_nome" },
      { text: "Vendedor", value: "vendedor_nome" },
      { text: "Forma de pagamento", value: "tipo_de_pagamento_descricao" },
      { text: "Valor", value: "total_venda", width: 150 }
    ],
    advanced_filters: {
      tipo_de_pagamento_id: []
    },
    valor_filtro_selecionado: null,
    valor_outro_de: null,
    valor_outro_ate: null,
    total_options: [
      {
        text: "Todos",
        value: null
      },
      {
        text: "até R$ 100,00",
        value: {
          from: 0,
          to: 100
        }
      },
      {
        text: "até R$ 500,00",
        value: {
          from: 0,
          to: 500
        }
      },
      {
        text: "até R$ 1.000,00",
        value: {
          from: 0,
          to: 1000
        }
      },
      {
        text: "> R$ 1.000,00",
        value: {
          from: 1000,
          to: null
        }
      },
      {
        text: "Outro",
        value: "outro"
      }
    ]
  }),
  methods: {
    handleFilter() {
      this.options.page = 1;
      this.persistState();
      this.fetchReport();
    },
    toggleFilters() {
      this.showFilters = !this.showFilters;
      this.persistState();
    },
    resetAdvancedFilters() {
      this.advanced_filters = { tipo_de_pagamento_id: [] };
      this.valor_filtro_selecionado = null;
      this.valor_outro_de = null;
      this.valor_outro_ate = null;
      this.persistState();
      this.fetchReport();
    },
    onAlterarFiltroValor(value) {
      if (value === "outro") {
        this.atualizarValorOutro();
      } else {
        this.advanced_filters.total_venda = value;
      }
    },
    onAlterarValorOutroDe(value) {
      this.valor_outro_de = value;
      this.atualizarValorOutro();
    },
    onAlterarValorOutroAte(value) {
      this.valor_outro_ate = value;
      this.atualizarValorOutro();
    },
    atualizarValorOutro() {
      const from =
        this.valor_outro_de !== null && this.valor_outro_de !== ""
          ? Number(this.valor_outro_de)
          : undefined;
      const to =
        this.valor_outro_ate !== null && this.valor_outro_ate !== ""
          ? Number(this.valor_outro_ate)
          : undefined;

      this.advanced_filters.total_venda =
        from === undefined && to === undefined ? null : { from, to };
    },
    setVendasAVista() {
      this.advanced_filters.tipo_de_pagamento_id = this.payment_types
        .filter(payment_type => !payment_type.use_local_credit)
        .map(payment_type => payment_type.id);
    },
    setCrediario() {
      this.advanced_filters.tipo_de_pagamento_id = this.payment_types
        .filter(payment_type => payment_type.use_local_credit)
        .map(payment_type => payment_type.id);
    },
    async getPaymentTypes() {
      this.payment_types = await indexPaymentTypes();
    },
    indexUsers() {
      const { sortBy, sortDesc, page, itemsPerPage } = {
        sortBy: ["name"],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 99
      };

      return this.$http.get(
        `/users?&page=${page}&perPage=${itemsPerPage}&orderBy=${
          sortBy[0] ? sortBy[0] : ""
        }&sortDesc=${sortDesc[0] ? sortDesc[0] : ""}`
      );
    },
    async getUsers() {
      const response = await this.indexUsers();
      this.users = response.data.data;
    },
    async fetchReport() {
      this.loading = true;
      try {
        this.items = [];
        const response = await index(this.options, this.advanced_filters);

        this.items = response.data;
        this.total_items = response.total;
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: "Falha ao carregar relatório",
          color: "red"
        });
      } finally {
        this.loading = false;
      }
    },
    formatMoney(value) {
      const money = Number(value || 0);
      return formatMoney(money);
    },
    persistState() {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          options: this.options,
          advanced_filters: this.advanced_filters,
          valor_filtro_selecionado: this.valor_filtro_selecionado,
          valor_outro_de: this.valor_outro_de,
          valor_outro_ate: this.valor_outro_ate,
          showFilters: this.showFilters
        })
      );
    },
    restoreState() {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return;

      try {
        const {
          options,
          advanced_filters,
          valor_filtro_selecionado,
          valor_outro_de,
          valor_outro_ate,
          showFilters
        } = JSON.parse(raw);
        if (options) this.options = options;
        if (advanced_filters) this.advanced_filters = advanced_filters;
        if (valor_filtro_selecionado !== undefined) {
          this.valor_filtro_selecionado = valor_filtro_selecionado;
        }
        if (valor_outro_de !== undefined) this.valor_outro_de = valor_outro_de;
        if (valor_outro_ate !== undefined) {
          this.valor_outro_ate = valor_outro_ate;
        }
        if (showFilters !== undefined) this.showFilters = showFilters;
      } catch (error) {
        console.error("Falha ao converter opções do relatório");
      }
    }
  },
  watch: {
    options: {
      handler() {
        this.persistState();
        this.fetchReport();
      },
      deep: true
    }
  },
  created() {
    this.getUsers();
    this.getPaymentTypes();
    this.restoreState();
  }
};
</script>
